module.exports = __webpack_public_path__ + "img/k.0c7c89a3.png";